export const SIGLA_CONSOLE = 'CONSOLE';
export const SIGLA_ADMINISTRATIVO = 'ADMINISTRATIVO';
export const CONFIG_IDS_VISIVEIS = 'config_ids_visiveis';

/** JSON Schema `format: color` — hex #RRGGBB (input type=color). */
export const FORMATO_COR = 'color';
export const PADRAO_COR_HEX = /^#([0-9A-Fa-f]{6})$/;
export const COR_HEX_INPUT_VAZIO = '#000000';

/** Anotação de schema que vincula uma propriedade a uma etapa customizada de UI. */
export const ANOTACAO_ETAPA_CUSTOMIZADA = 'x-etapaCustomizada';

export const ETAPAS_CUSTOMIZADAS = {
    ENVIO_EMAILS: 'envioEmails',
};

export const EMAILS_CHAVE = 'emails';

/** Upload de imagens (espelha CONSTANTES.IMAGENS do backend). */
export const IMAGEM_TIPOS_ACEITOS = ['image/png', 'image/jpeg', 'image/webp', 'image/svg+xml'];
export const IMAGEM_TAMANHO_MAXIMO_BYTES = 5 * 1024 * 1024;

export const EMAIL_TIPOS = {
    NOVA_SENHA: 'novaSenha',
    AUTO_CADASTRO: 'autoCadastro',
    ALTERACAO_PERFIL_ADMIN_LOCAL: 'alteracaoPerfilAdminLocal',
};

export const EMAIL_CAMPOS = {
    ASSUNTO: 'assunto',
    CORPO: 'corpo',
};

/** Catálogo fixo de variáveis Handlebars por tipo de e-mail. */
export const EMAIL_VARIAVEIS = {
    [EMAIL_TIPOS.NOVA_SENHA]: ['base', 'usuario', 'senha', 'enderecoAcesso'],
    [EMAIL_TIPOS.AUTO_CADASTRO]: ['base', 'nome', 'usuario', 'senha', 'enderecoAcesso'],
    [EMAIL_TIPOS.ALTERACAO_PERFIL_ADMIN_LOCAL]: ['base', 'enderecoAcesso'],
};

export const EMAIL_TIPOS_OPCOES = [
    {
        valor: EMAIL_TIPOS.NOVA_SENHA,
        rotuloKey: 'emailTipoNovaSenha',
        rotuloPadrao: 'Nova senha',
    },
    {
        valor: EMAIL_TIPOS.AUTO_CADASTRO,
        rotuloKey: 'emailTipoAutoCadastro',
        rotuloPadrao: 'Auto-cadastro',
    },
    {
        valor: EMAIL_TIPOS.ALTERACAO_PERFIL_ADMIN_LOCAL,
        rotuloKey: 'emailTipoAlteracaoPerfil',
        rotuloPadrao: 'Alteração de perfil por administrador local',
    },
];

export const emailsVazios = () => ({
    [EMAIL_TIPOS.NOVA_SENHA]: { [EMAIL_CAMPOS.ASSUNTO]: '', [EMAIL_CAMPOS.CORPO]: '' },
    [EMAIL_TIPOS.AUTO_CADASTRO]: { [EMAIL_CAMPOS.ASSUNTO]: '', [EMAIL_CAMPOS.CORPO]: '' },
    [EMAIL_TIPOS.ALTERACAO_PERFIL_ADMIN_LOCAL]: { [EMAIL_CAMPOS.ASSUNTO]: '', [EMAIL_CAMPOS.CORPO]: '' },
});

export const tokenVariavel = (chave) => `{{${chave}}}`;

export default {
    SIGLA_CONSOLE,
    SIGLA_ADMINISTRATIVO,
    CONFIG_IDS_VISIVEIS,
    FORMATO_COR,
    PADRAO_COR_HEX,
    COR_HEX_INPUT_VAZIO,
    ANOTACAO_ETAPA_CUSTOMIZADA,
    ETAPAS_CUSTOMIZADAS,
    EMAILS_CHAVE,
    IMAGEM_TIPOS_ACEITOS,
    IMAGEM_TAMANHO_MAXIMO_BYTES,
    EMAIL_TIPOS,
    EMAIL_CAMPOS,
    EMAIL_VARIAVEIS,
    EMAIL_TIPOS_OPCOES,
    emailsVazios,
    tokenVariavel,
};
